import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { SavedLocationTableManager } from '@hero/web-components';

/**
 * Standalone org-wide places surface mounted under `/more/places`.
 * Reuses `SavedLocationTableManager`, which mounts its own
 * SavedLocation/Order drawers when `renderDrawers={true}`.
 */
export default function PlacesPage() {
  const { t } = useTranslation(['m-location', 'applications']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('applications:Places.title', { defaultValue: 'Places' }));
  }, [setPageName, t]);

  return (
    <div className="mt-6">
      <SavedLocationTableManager displayForUser="carrier" renderDrawers={false} redirect />
    </div>
  );
}
